<div [formGroup]="innerFormGroup" class="form-inline" style="min-width: 280px">
  <div #outlet class="input-group mr-2">
    <igx-date-picker #datePicker [outlet]="outlet" locale="ja-JP" formControlName="date" (opened)="onDatePickerOpened()"
      (closed)="onDatePickerClosed()" (valueChange)="onSelection()" [inputFormat]="'yyyy/MM/dd'"
      [placeholder]="'YYYY/MM/DD'">
      <ng-template igxPickerActions let-calendar>
        <div class="action-buttons">
          <button igxButton="flat" type="button" (click)="moveToday()">今日</button>
        </div>
      </ng-template>
    </igx-date-picker>
  </div>
  <select class="form-control input-time mr-1" formControlName="hour" placeholder="HH">
    <option *ngIf="!hour.value" [value]="null"></option>
    <option *ngFor="let h of hours" [value]="h">{{ h }}</option>
  </select>
  <select class="form-control input-time" formControlName="minute" placeholder="mm">
    <option *ngIf="!minute.value" [value]="null"></option>
    <option *ngFor="let m of minutes" [value]="m">{{ m }}</option>
  </select>
</div>
